// @flow

import Review from './review';
import ACFReview from './review.acf';
import type { ReviewProps, ACFProps } from './types';

export type {
  ReviewProps,
  ACFProps,
};

export {
  ACFReview,
};

export default Review;
